// Completa una URL que devuelve el store API con el endpoint de la tienda activa.
// Las versiones de orden nuevas guardan una ruta relativa al API
// ("orders/invoice_version/…"); las antiguas, la URL absoluta del PDF en S3.
export function resolveStoreApiUrl(url, endpoint) {
  if (!url || /^https?:\/\//i.test(url)) {
    return url;
  }
  return `${String(endpoint).replace(/\/+$/, "")}/${url.replace(/^\/+/, "")}`;
}
